import React, { useState } from "react";
import AppLayout from "../../components/AppLayout";
import {
  Box,
  TextField,
  Button,
  Tabs,
  Tab,
  Grid,
  Avatar,
  IconButton,
  Typography,
  Paper,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

export default function CreateInventory() {
  const gold = "#BC965E";
  const inputStyle = {
    bgcolor: "white",
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: gold, borderWidth: 2 },
      "&:hover fieldset": { borderColor: gold },
      "&.Mui-focused fieldset": { borderColor: gold },
    },
    "& input::placeholder": {
      color: gold,
      opacity: 1,
    },
  };

  const emptyForm = {
    productCode: "",
    productName: "",
    partyName: "",
    price: "",
    quantity: "",
    invoiceNumber: "",
    gstNumber: "",
    dateOfPurchase: "",
    sizes: [""],
  };

  const [tab, setTab] = useState(0); // 0 = Products, 1 = Raw Materials
  const [image, setImage] = useState(null);
  const [formData, setFormData] = useState({ ...emptyForm });
  const [additionalForms, setAdditionalForms] = useState([]); // dynamic form sets

  const handleChange = (e, formIndex = null) => {
    const { name, value } = e.target;
    if (formIndex === null) {
      setFormData((p) => ({ ...p, [name]: value }));
    } else {
      const updatedForms = [...additionalForms];
      updatedForms[formIndex][name] = value;
      setAdditionalForms(updatedForms);
    }
  };

  const handleSizeChange = (i, value, formIndex = null) => {
    if (formIndex === null) {
      const updated = [...formData.sizes];
      updated[i] = value;
      setFormData((p) => ({ ...p, sizes: updated }));
    } else {
      const updatedForms = [...additionalForms];
      const updatedSizes = [...updatedForms[formIndex].sizes];
      updatedSizes[i] = value;
      updatedForms[formIndex].sizes = updatedSizes;
      setAdditionalForms(updatedForms);
    }
  };

  const addSizeField = (formIndex = null) => {
    if (formIndex === null) {
      setFormData((p) => ({ ...p, sizes: [...p.sizes, ""] }));
    } else {
      const updatedForms = [...additionalForms];
      updatedForms[formIndex].sizes.push("");
      setAdditionalForms(updatedForms);
    }
  };

  const addFormSet = () => {
    setAdditionalForms((p) => [...p, { ...emptyForm }]);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setImage(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleSave = () => {
    // Add your save logic here
  };

  const navigate = useNavigate();

  const renderForm = (data, index = null) => (
    <Box key={index ?? "main"} sx={{ mt: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="productCode"
            value={data.productCode}
            onChange={(e) => handleChange(e, index)}
            placeholder="Product Code"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="productName"
            value={data.productName}
            onChange={(e) => handleChange(e, index)}
            placeholder="Product Name"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="partyName"
            value={data.partyName}
            onChange={(e) => handleChange(e, index)}
            placeholder="Party Name"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="price"
            value={data.price}
            onChange={(e) => handleChange(e, index)}
            placeholder="Price"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="quantity"
            value={data.quantity}
            onChange={(e) => handleChange(e, index)}
            placeholder="Quantity"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="invoiceNumber"
            value={data.invoiceNumber}
            onChange={(e) => handleChange(e, index)}
            placeholder="Invoice Number"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="gstNumber"
            value={data.gstNumber}
            onChange={(e) => handleChange(e, index)}
            placeholder="GST Number"
            sx={inputStyle}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            type="date"
            name="dateOfPurchase"
            value={data.dateOfPurchase}
            onChange={(e) => handleChange(e, index)}
            placeholder="Date of Purchase"
            InputLabelProps={{ shrink: true }}
            sx={inputStyle}
          />
        </Grid>
      </Grid>

      {/* Sizes */}
      <Box sx={{ mt: 2 }}>
        {data.sizes.map((size, i) => (
          <Grid container spacing={2} key={i} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                value={size}
                onChange={(e) => handleSizeChange(i, e.target.value, index)}
                placeholder={`Size ${i + 1}`}
                sx={inputStyle}
              />
            </Grid>
          </Grid>
        ))}
        <Button
          startIcon={<AddIcon />}
          onClick={() => addSizeField(index)}
          sx={{
            color: gold,
            border: `2px solid ${gold}`,
            mt: 1,
            fontWeight: 600,
          }}
        >
          Add Another Size
        </Button>
      </Box>
    </Box>
  );

  return (
    <AppLayout>
      <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1300, mx: "auto" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
          <Button
            variant="contained"
            sx={{ bgcolor: gold }}
            onClick={() => navigate("/inventory")}
          >
            Previous
          </Button>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            ADD ITEM
          </Typography>
          <Box />
        </Box>

        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          textColor="primary"
          indicatorColor="primary"
          sx={{ mb: 3, borderBottom: `2px solid ${gold}` }}
        >
          <Tab label="PRODUCTS" />
          <Tab label="RAW MATERIALS" />
        </Tabs>

        <Paper
          sx={{
            p: 3,
            border: `1px solid ${gold}`,
            borderRadius: 2,
            bgcolor: "rgba(188,150,94,0.1)",
          }}
        >
          {/* Image Upload */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <input
              hidden
              accept="image/*"
              id="upload-img"
              type="file"
              onChange={handleImageUpload}
            />
            <label htmlFor="upload-img">
              <Box
                sx={{
                  width: 150,
                  height: 150,
                  position: "relative",
                  mx: "auto",
                  cursor: "pointer",
                }}
              >
                <Avatar
                  src={image}
                  sx={{
                    width: "100%",
                    height: "100%",
                    bgcolor: "#D4AF8E",
                    fontSize: "3rem",
                  }}
                >
                  {!image && "📷"}
                </Avatar>
                <IconButton
                  component="span"
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    bgcolor: "white",
                    border: `2px solid ${gold}`,
                  }}
                >
                  <PhotoCameraIcon sx={{ color: gold }} />
                </IconButton>
              </Box>
            </label>
          </Box>

          {/* MAIN FORM */}
          {renderForm(formData)}

          {/* ADDITIONAL FORM SETS */}
          {additionalForms.map((f, i) => renderForm(f, i))}

          {/* ACTION BUTTONS */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
            <Button
              variant="contained"
              sx={{
                bgcolor: "#C4A574",
                color: "white",
                px: 4,
                py: 1.5,
                fontWeight: 600,
                "&:hover": { bgcolor: "#B39562" },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              sx={{
                bgcolor: gold,
                color: "white",
                px: 4,
                py: 1.5,
                fontWeight: 600,
                "&:hover": { bgcolor: "#A9824A" },
              }}
              onClick={addFormSet}
            >
              Add Another
            </Button>
          </Box>
        </Paper>
      </Box>
    </AppLayout>
  );
}
